import { observable, computed, makeObservable } from 'mobx';
import { serializable } from 'serializr';

export class AdjustedValue {
  constructor() {
    makeObservable(this);
  }

  @serializable
  @observable
  initial = 0;

  @serializable
  @observable
  adjustedBy = 0;

  @serializable
  @observable
  fromTag = 0;

  @computed get total() {
    return this.initial + this.adjustedBy + this.fromTag;
  }
}
